import { FC, useMemo } from 'react';
import { Box, Grid, GridItem } from '@chakra-ui/react';
import { Image } from '../../Common/Image';
import { FarmFragment } from '../../../generated/types';
import { ImageSlider } from '../../Common/ImageSlider';
import { ImageWithDerivative } from '../../../types/global';

interface FarmImagesProps {
  data: FarmFragment;
}

export const FarmImages: FC<FarmImagesProps> = ({ data }) => {
  const images = useMemo<ImageWithDerivative[]>(() => {
    const images: ImageWithDerivative[] = [];

    if (data.teaserImage) {
      images.push(data.teaserImage);
    }

    data.images?.forEach((image) => images.push(image));

    return images;
  }, [data]);

  if (!images.length) return null;

  return (
    <>
      <Box
        display={{
          base: 'block',
          md: 'none',
        }}
      >
        <ImageSlider images={images} />
      </Box>
      <Box
        display={{
          base: 'none',
          md: 'block',
        }}
      >
        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem
            rowSpan={images.length > 2 ? 2 : 1}
            colSpan={images.length > 1 ? 8 : 12}
          >
            <Image
              imageStyle={images[0].imageStyle}
              image={images[0]}
              copyrightInside
            />
          </GridItem>
          {images.length > 1 && (
            <>
              <GridItem colSpan={4}>
                <Image
                  imageStyle={images[1].imageStyle}
                  image={images[1]}
                  copyrightInside
                />
              </GridItem>
              {images.length > 2 && (
                <GridItem colSpan={4}>
                  <Image
                    imageStyle={images[2].imageStyle}
                    image={images[2]}
                    copyrightInside
                  />
                </GridItem>
              )}
            </>
          )}
        </Grid>
      </Box>
    </>
  );
};
